import { Extension } from '@tiptap/core';
import type { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

const MERGE_TAG_PATTERN = /\{\{\s*[\w.]+\s*\}\}/g;

const buildMergeTagDecorations = (doc: ProseMirrorNode) => {
  const decorations: Decoration[] = [];
  doc.descendants((node, pos) => {
    if (!node.isText || !node.text) return;
    const matcher = new RegExp(MERGE_TAG_PATTERN.source, 'g');
    let match = matcher.exec(node.text);
    while (match) {
      const from = pos + match.index;
      const to = from + match[0].length;
      decorations.push(Decoration.inline(from, to, { class: 'lead-merge-tag' }));
      match = matcher.exec(node.text);
    }
  });
  return DecorationSet.create(doc, decorations);
};

/** Highlights {{merge_tag}} tokens in the editor without persisting chip markup. */
export const LeadMergeTagHighlight = Extension.create({
  name: 'leadMergeTagHighlight',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('leadMergeTagHighlight'),
        props: {
          decorations(state) {
            return buildMergeTagDecorations(state.doc);
          },
        },
      }),
    ];
  },
});
